import React from "react";
import loginGirl from "./assets/login-girl.png";
import LoginForm from "./login_form";

const Login: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-[#F3F5F6]">
      {/* Left side - Image */}
      <div className="hidden md:block w-2/3 h-full p-10">
        <div className="h-full rounded-lg overflow-hidden">
          <img
            src={loginGirl}
            alt="Login illustration"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Right side - Login form */}
      <div className="w-full md:w-1/3 flex justify-center items-center mr-10 bg-white rounded-lg">
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
